import qs from 'qs';
import { network } from 'services/network';

export const removeReportComment = (id) => {
    const queryString = qs.stringify({ commentId: id }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/reporting/removeReportComment${queryString}`;
    return network.get(url).then((response) => {
        return response.data;
    });
};
